import styles from '../styles.module.css';
import DeleteIcon from '@/assets/icons/delete.svg?react';
import {
  AdminCardBody,
  AdminCardHeader
} from '@/components/AdminToolComponents/card';
import { Button } from '@/components/Form/Button';

interface AdminDeleteSectionProps {
  title: string;
  onDeleteClick: () => void;
  text?: string;
  buttonLabel?: string;
  loading?: boolean;
}

const DEFAULT_BUTTON_LABEL = 'DELETE PERMANENTLY';
const DEFAULT_TEXT = 'This action can not be undone';

export const AdminDeleteSection = ({
  title,
  onDeleteClick,
  text = DEFAULT_TEXT,
  buttonLabel = DEFAULT_BUTTON_LABEL,
  loading = false
}: AdminDeleteSectionProps) => (
  <div className={styles.adminContainer}>
    <AdminCardHeader
      left={
        <>
          <DeleteIcon className={styles.adminIconHeader} />
          <h2 className={styles.adminTitle}>{title}</h2>
        </>
      }
    />
    <AdminCardBody>
      <div className={styles.adminContainerRow}>
        <Button
          onClick={onDeleteClick}
          color="red"
          solid={false}
          label={buttonLabel}
          size="large"
          loading={loading}
        />
        <h4 className={styles.adminText}>{text}</h4>
      </div>
    </AdminCardBody>
  </div>
);
